export default {
    "zh": {
        "pageTitle": "Higgsfield AI视频生成器 - AI电影级镜头创作平台",
        "pageDescription": "体验Higgsfield AI视频生成器，专注于电影级镜头控制和视觉叙事。通过精准的镜头调度和视觉指导，创作具有导演感的AI视频内容。在WeryAI平台免费试用。",
        "pageKeywords": "Higgsfield AI, AI视频生成器, 电影级视频, 镜头控制, 视频制作, 免费AI视频, WeryAI, 视频生成",
        "generatorTitle": "Higgsfield AI 视频生成器",
        "generatorDescription": "WeryAI 现已深度集成 Higgsfield AI 模型。Higgsfield AI 专注于<span class=\"highlight-bold\">电影级镜头控制</span>，让创作者能够<span class=\"highlight-bold\">精准指导每个镜头的运动和视觉语言</span>。不只是生成视频，而是真正<span class=\"highlight-bold\">导演每一个画面</span>。立即<span class=\"highlight-bold\">免费试用 Higgsfield AI</span>！",
        "tabImageToVideo": "图生视频",
        "tabTextToVideo": "文生视频",
        "coreFeaturesTitle": "Higgsfield AI 的主要功能",
        "coreFeaturesSubtitle": "赋予每个瞬间独特的视角",
        "cameraAwareDirectionTitle": "镜头感知指导",
        "cameraAwareDirectionDescription": "描述观众如何进入、跟随和离开场景，而不是满足于通用的运动效果。",
        "referenceGuidedContinuityTitle": "参考引导的连续性",
        "referenceGuidedContinuityDescription": "用图像锚定变体，让主体、色调和构图保持统一的视觉风格。",
        "shortFormSceneRhythmTitle": "短视频场景节奏",
        "shortFormSceneRhythmDescription": "围绕清晰的视觉瞬间，构思产品展示、编辑节奏和社交故事。",
        "instantFirstFrameTitle": "即时首帧生成",
        "instantFirstFrameDescription": "快速锁定开场画面，为整个视频建立统一的视觉基调和风格方向。",
        "imageToCinematicTitle": "图像动画化",
        "imageToCinematicDescription": "将静态图片转化为流畅的电影级动态镜头，让每一帧都充满生命力和叙事张力。",
        "commercialTitle": "商业级输出品质",
        "commercialDescription": "提供4K高清分辨率和专业级色彩管理，满足商业项目和品牌推广的严格要求。",
        "onestopWorkflowTitle": "一站式创作工作流",
        "onestopWorkflowDescription": "从脚本到成片，整合提示词优化、镜头生成、变体探索的完整创作流程。",
        "howToUseTitle": "如何使用",
        "howToUseSubtitle": "简单三步，开始创作",
        "step1Title": "选择 Higgsfield AI 模型",
        "step1Description": "前往<span class=\"highlight-text\">\"AI视频生成\"</span>页面，然后在模型下拉菜单中点击\"Higgsfield AI\"。",
        "step2Title": "定义镜头语言",
        "step2Description": "描述场景、动作、氛围和你想捕捉的瞬间，或上传参考图片设定视觉方向。",
        "step3Title": "生成并优化",
        "step3Description": "点击\"创建\"生成视频，对比不同版本，选择最有说服力的镜头并继续优化。",
        "youtubeTitle": "关于 Higgsfield AI 视频模型的 YouTube 视频",
        "youtubeVideosTitle": "关于 Higgsfield AI 视频模型的 YouTube 视频",
        "youtubeVideoTitle": "关于 Higgsfield AI 视频模型的 YouTube 视频",
        "xPostsTitle": "关于 Higgsfield AI 视频模型的热门 X 帖子",
        "exploreModelsTitle": "探索其他模型",
        "sora2Title": "OpenAI Sora-2 AI 视频生成器",
        "hailuoTitle": "Hailuo AI 视频生成器",
        "klingTitle": "Kling AI 视频生成器",
        "faqTitle": "常见问题解答",
        "ctaTitle": "准备开始创作了吗？",
        "ctaSubtitle": "立即体验 Higgsfield AI，将您的创意转化为电影级视频",
        "ctaDescription": "从值得追随的镜头开始，将清晰的视觉指导转化为电影感的短视频创意",
        "ctaButton": "在 WeryAI 上试用 Higgsfield AI",
        "ctaNote": "无需信用卡",
        "ctaDisclaimer": "无需信用卡",
        "videoNotSupported": "您的浏览器不支持视频播放",
        "videoUnsupported": "您的浏览器不支持视频播放",
        "videoLoadingError": "视频加载失败",
        "videoLoadError": "视频加载失败",
        "videoReload": "重新加载"
    },
    "en": {
        "pageTitle": "Higgsfield AI Video Generator - AI Cinematic Shot Creation Platform",
        "pageDescription": "Experience the Higgsfield AI video generator, focusing on cinematic-level camera control and visual storytelling. Create AI video content with a directorial feel through precise camera scheduling and visual guidance. Try it for free on the WeryAI platform.",
        "pageKeywords": "Higgsfield AI, AI video generator, cinematic video, camera control, video production, free AI videos, WeryAI, video generation",
        "generatorTitle": "Higgsfield AI Video Generator",
        "generatorDescription": "<span class=\"highlight-bold\">WeryAI is now deeply integrated with the Higgsfield AI model. Higgsfield AI focuses on cinematic-level shot control, enabling creators to precisely direct the movement and visual language of each shot. It's not just about generating videos, but truly directing every frame. Try Higgsfield AI for free now!</span>",
        "tabImageToVideo": "Image-generated video",
        "tabTextToVideo": "Wensheng Video",
        "coreFeaturesTitle": "Main Features of Higgsfield AI",
        "coreFeaturesSubtitle": "Give each moment a unique perspective",
        "cameraAwareDirectionTitle": "Camera Perception Guidance",
        "cameraAwareDirectionDescription": "Describe how the audience enters, follows, and leaves the scene, rather than being satisfied with generic motion effects.",
        "referenceGuidedContinuityTitle": "Reference-guided continuity",
        "referenceGuidedContinuityDescription": "Use image anchors for variants, keeping the subject, tone, and composition consistent with the visual style.",
        "shortFormSceneRhythmTitle": "Short video scene rhythm",
        "shortFormSceneRhythmDescription": "Around clear visual moments, design product displays, editing rhythms, and social stories.",
        "instantFirstFrameTitle": "Real-time first frame generation",
        "instantFirstFrameDescription": "Quickly lock in the opening screen to establish a consistent visual tone and style direction for the entire video.",
        "imageToCinematicTitle": "Image Animation",
        "imageToCinematicDescription": "Transform static images into smooth, cinematic dynamic shots, making every frame full of vitality and narrative tension.",
        "commercialTitle": "Commercial-grade output quality",
        "commercialDescription": "Provides 4K high-definition resolution and professional-grade color management, meeting the strict requirements of commercial projects and brand promotion.",
        "onestopWorkflowTitle": "One-stop creative workflow",
        "onestopWorkflowDescription": "From script to final product, a complete creative workflow that integrates prompt optimization, shot generation, and variant exploration.",
        "howToUseTitle": "How to use",
        "howToUseSubtitle": "Three simple steps to start creating",
        "step1Title": "Select Higgsfield AI model",
        "step1Description": "<span class=\"highlight-text\">Go to the 'AI Video Generation' page, then click 'Higgsfield AI' in the model dropdown menu.</span>",
        "step2Title": "Define cinematography language",
        "step2Description": "Describe the scene, actions, atmosphere, and the moment you want to capture, or upload reference images to set the visual direction.",
        "step3Title": "Generate and optimize",
        "step3Description": "Click 'Create' to generate the video, compare different versions, choose the most persuasive shots, and continue to optimize.",
        "youtubeTitle": "YouTube videos about the Higgsfield AI video model",
        "youtubeVideosTitle": "YouTube videos about the Higgsfield AI video model",
        "youtubeVideoTitle": "YouTube videos about the Higgsfield AI video model",
        "xPostsTitle": "Popular X posts about Higgsfield AI video model",
        "exploreModelsTitle": "Explore other models",
        "sora2Title": "OpenAI Sora-2 AI Video Generator",
        "hailuoTitle": "Hailuo AI Video Generator",
        "klingTitle": "Kling AI Video Generator",
        "faqTitle": "Frequently Asked Questions",
        "ctaTitle": "Are you ready to start creating?",
        "ctaSubtitle": "Experience Higgsfield AI immediately and turn your ideas into cinematic-quality videos",
        "ctaDescription": "Start with a shot worth following, transforming clear visual guidance into cinematic short video ideas",
        "ctaButton": "Try Higgsfield AI on WeryAI",
        "ctaNote": "No credit card required",
        "ctaDisclaimer": "No credit card required",
        "videoNotSupported": "Your browser does not support video playback",
        "videoUnsupported": "Your browser does not support video playback",
        "videoLoadingError": "Video failed to load",
        "videoLoadError": "Video failed to load",
        "videoReload": "Reload"
    },
    "ja": {
        "pageTitle": "Higgsfield AI動画ジェネレーター - AI映画的ショット作成プラットフォーム",
        "pageDescription": "Higgsfield AI動画ジェネレーターを体験。映画的なカメラコントロールとビジュアルストーリーテリングに特化。精密なカメラ演出とビジュアルガイダンスで監督品質のAI動画コンテンツを作成。WeryAIプラットフォームで無料試用。",
        "pageKeywords": "Higgsfield AI, AI動画ジェネレーター, 映画的動画, カメラコントロール, 動画制作, 無料AI動画, WeryAI, 動画生成",
        "generatorTitle": "Higgsfield AI動画ジェネレーター",
        "generatorDescription": "WeryAIはHiggsfield AIモデルを深く統合しました。Higgsfield AIは<span class=\"highlight-bold\">映画的なカメラコントロール</span>に焦点を当て、クリエイターが<span class=\"highlight-bold\">各ショットの動きと視覚言語を正確に指示</span>できます。単に動画を生成するだけでなく、本当に<span class=\"highlight-bold\">すべてのフレームを演出</span>します。今すぐ<span class=\"highlight-bold\">無料でHiggsfield AIを試す</span>！",
        "tabImageToVideo": "画像から動画",
        "tabTextToVideo": "テキストから動画",
        "coreFeaturesTitle": "Higgsfield AI の主要機能",
        "coreFeaturesSubtitle": "すべての瞬間に視点を与える",
        "cameraAwareDirectionTitle": "カメラ認識演出",
        "cameraAwareDirectionDescription": "視聴者がどのようにシーンに入り、追跡し、離れるかを記述し、一般的なモーションで妥協しません。",
        "referenceGuidedContinuityTitle": "参照ガイド付き連続性",
        "referenceGuidedContinuityDescription": "画像でバリエーションを固定し、被写体、パレット、フレーミングがあなたのものだと認識できるように保ちます。",
        "shortFormSceneRhythmTitle": "短編シーンリズム",
        "shortFormSceneRhythmDescription": "明確な視覚的瞬間を中心に、製品の公開、編集ビート、ソーシャルストーリーを開発します。",
        "instantFirstFrameTitle": "即時最初のフレーム",
        "instantFirstFrameDescription": "オープニングショットを素早く固定し、動画全体の統一された視覚的トーンとスタイル方向を確立します。",
        "imageToCinematicTitle": "画像をシネマティックに",
        "imageToCinematicDescription": "静止画像を滑らかな映画的ショットに変換し、すべてのフレームに生命力と物語性を与えます。",
        "commercialTitle": "商業グレードの品質",
        "commercialDescription": "4K高解像度とプロフェッショナルなカラーマネジメントを提供し、商業プロジェクトとブランドプロモーションの厳格な要件を満たします。",
        "onestopWorkflowTitle": "ワンストップクリエイティブワークフロー",
        "onestopWorkflowDescription": "スクリプトから最終カットまで、プロンプト最適化、ショット生成、バリアント探索を統合した完全なクリエイティブプロセス。",
        "howToUseTitle": "使用方法",
        "howToUseSubtitle": "簡単3ステップで開始",
        "step1Title": "Higgsfield AIモデル選択",
        "step1Description": "<span class=\"highlight-text\">「AI動画生成」</span>ページに移動し、モデルドロップダウンメニューで「Higgsfield AI」をクリックします。",
        "step2Title": "ショット言語を定義",
        "step2Description": "キャプチャしたいシーン、アクション、雰囲気、瞬間を記述するか、参照画像をアップロードして視覚的な方向を設定します。",
        "step3Title": "生成して洗練",
        "step3Description": "「作成」をクリックして動画を生成し、バージョンを比較し、最も説得力のあるショットを選択して洗練を続けます。",
        "youtubeTitle": "Higgsfield AI動画モデルに関するYouTube動画",
        "youtubeVideosTitle": "Higgsfield AI動画モデルに関するYouTube動画",
        "youtubeVideoTitle": "Higgsfield AI動画モデルに関するYouTube動画",
        "xPostsTitle": "Higgsfield AI動画モデルに関するX投稿",
        "exploreModelsTitle": "他のモデルを探索",
        "sora2Title": "OpenAI Sora-2 AI動画ジェネレーター",
        "hailuoTitle": "Hailuo AI動画ジェネレーター",
        "klingTitle": "Kling AI動画ジェネレーター",
        "faqTitle": "よくある質問",
        "ctaTitle": "作成を始める準備はできましたか？",
        "ctaSubtitle": "今すぐHiggsfield AIを体験し、あなたの創造性を映画的な動画に変換",
        "ctaDescription": "フォローする価値のあるショットから始め、明確な視覚的方向を映画的な短編コンセプトに変換",
        "ctaButton": "WeryAIでHiggsfield AIを試す",
        "ctaNote": "クレジットカード不要",
        "ctaDisclaimer": "クレジットカード不要",
        "videoNotSupported": "お使いのブラウザは動画再生をサポートしていません",
        "videoUnsupported": "お使いのブラウザは動画再生をサポートしていません",
        "videoLoadingError": "動画の読み込みに失敗しました",
        "videoLoadError": "動画の読み込みに失敗しました",
        "videoReload": "再読み込み"
    },
    "ko": {
        "pageTitle": "Higgsfield AI 비디오 생성기 - AI 영화적 샷 생성 플랫폼",
        "pageDescription": "Higgsfield AI 비디오 생성기를 체험하세요. 영화적 카메라 제어와 비주얼 스토리텔링에 특화. 정밀한 카메라 연출과 비주얼 가이던스로 감독 수준의 AI 비디오 콘텐츠를 생성합니다. WeryAI 플랫폼에서 무료로 체험하세요.",
        "pageKeywords": "Higgsfield AI, AI 비디오 생성기, 영화적 비디오, 카메라 제어, 비디오 제작, 무료 AI 비디오, WeryAI, 비디오 생성",
        "generatorTitle": "Higgsfield AI 비디오 생성기",
        "generatorDescription": "WeryAI는 이제 Higgsfield AI 모델을 깊이 통합했습니다. Higgsfield AI는 <span class=\"highlight-bold\">영화적 카메라 제어</span>에 초점을 맞춰 창작자가 <span class=\"highlight-bold\">모든 샷의 움직임과 시각적 언어를 정밀하게 연출</span>할 수 있게 합니다. 단순히 비디오를 생성하는 것이 아니라 정말로 <span class=\"highlight-bold\">모든 프레임을 연출</span>합니다. 지금 <span class=\"highlight-bold\">무료로 Higgsfield AI를 체험</span>하세요!",
        "tabImageToVideo": "이미지에서 비디오",
        "tabTextToVideo": "텍스트에서 비디오",
        "coreFeaturesTitle": "Higgsfield AI 주요 기능",
        "coreFeaturesSubtitle": "모든 순간에 관점을 부여",
        "cameraAwareDirectionTitle": "카메라 인식 연출",
        "cameraAwareDirectionDescription": "시청자가 장면에 들어가고, 따라가고, 떠나는 방식을 설명하여 일반적인 모션에 만족하지 않습니다.",
        "referenceGuidedContinuityTitle": "참조 가이드 연속성",
        "referenceGuidedContinuityDescription": "이미지로 변형을 고정하여 주제, 팔레트, 프레이밍이 인식 가능하게 유지되도록 합니다.",
        "shortFormSceneRhythmTitle": "단편 장면 리듬",
        "shortFormSceneRhythmDescription": "명확한 시각적 순간을 중심으로 제품 공개, 편집 비트, 소셜 스토리를 개발합니다.",
        "instantFirstFrameTitle": "즉시 첫 프레임",
        "instantFirstFrameDescription": "오프닝 샷을 빠르게 고정하고 전체 비디오의 통일된 시각적 톤과 스타일 방향을 설정합니다.",
        "imageToCinematicTitle": "이미지를 영화적으로",
        "imageToCinematicDescription": "정적 이미지를 부드러운 영화 같은 샷으로 변환하여 모든 프레임에 생명력과 내러티브 긴장감을 부여합니다.",
        "commercialTitle": "상업용 품질",
        "commercialDescription": "4K 고해상도 및 전문 색상 관리를 제공하여 상업 프로젝트 및 브랜드 프로모션의 엄격한 요구 사항을 충족합니다.",
        "onestopWorkflowTitle": "원스톱 크리에이티브 워크플로우",
        "onestopWorkflowDescription": "스크립트부터 최종 편집까지, 프롬프트 최적화, 샷 생성, 변형 탐색을 통합한 완전한 창작 프로세스.",
        "howToUseTitle": "사용 방법",
        "howToUseSubtitle": "간단한 3단계로 시작",
        "step1Title": "Higgsfield AI 모델 선택",
        "step1Description": "<span class=\"highlight-text\">「AI 비디오 생성」</span> 페이지로 이동한 다음 모델 드롭다운 메뉴에서 「Higgsfield AI」를 클릭합니다.",
        "step2Title": "샷 언어 정의",
        "step2Description": "캡처하려는 장면, 액션, 분위기, 순간을 설명하거나 참조 이미지를 업로드하여 시각적 방향을 설정합니다.",
        "step3Title": "생성 및 세련화",
        "step3Description": "「생성」을 클릭하여 비디오를 생성하고 버전을 비교하여 가장 설득력 있는 샷을 선택하고 세련화를 계속합니다.",
        "youtubeTitle": "Higgsfield AI 비디오 모델에 대한 YouTube 비디오",
        "youtubeVideosTitle": "Higgsfield AI 비디오 모델에 대한 YouTube 비디오",
        "youtubeVideoTitle": "Higgsfield AI 비디오 모델에 대한 YouTube 비디오",
        "xPostsTitle": "Higgsfield AI 비디오 모델에 대한 X 게시물",
        "exploreModelsTitle": "다른 모델 탐색",
        "sora2Title": "OpenAI Sora-2 AI 비디오 생성기",
        "hailuoTitle": "Hailuo AI 비디오 생성기",
        "klingTitle": "Kling AI 비디오 생성기",
        "faqTitle": "자주 묻는 질문",
        "ctaTitle": "제작을 시작할 준비가 되셨나요?",
        "ctaSubtitle": "지금 Higgsfield AI를 체험하고 당신의 창의성을 영화적 비디오로 변환하세요",
        "ctaDescription": "따라갈 가치가 있는 샷으로 시작하여 명확한 시각적 방향을 영화적 단편 개념으로 전환",
        "ctaButton": "WeryAI에서 Higgsfield AI 체험",
        "ctaNote": "신용카드 불필요",
        "ctaDisclaimer": "신용카드 불필요",
        "videoNotSupported": "귀하의 브라우저는 비디오 재생을 지원하지 않습니다",
        "videoUnsupported": "귀하의 브라우저는 비디오 재생을 지원하지 않습니다",
        "videoLoadingError": "비디오 로딩 실패",
        "videoLoadError": "비디오 로딩 실패",
        "videoReload": "다시 로드"
    },
    "tw": {
        "pageTitle": "Higgsfield AI影片生成器 - AI電影級鏡頭創作平台",
        "pageDescription": "體驗Higgsfield AI影片生成器，專注於電影級鏡頭控制和視覺敘事。通過精準的鏡頭調度和視覺指導，創作具有導演感的AI影片內容。在WeryAI平台免費試用。",
        "pageKeywords": "Higgsfield AI, AI影片生成器, 電影級影片, 鏡頭控制, 影片製作, 免費AI影片, WeryAI, 影片生成",
        "generatorTitle": "Higgsfield AI 影片生成器",
        "generatorDescription": "WeryAI 現已深度整合 Higgsfield AI 模型。Higgsfield AI 專注於<span class=\"highlight-bold\">電影級鏡頭控制</span>，讓創作者能夠<span class=\"highlight-bold\">精準指導每個鏡頭的運動和視覺語言</span>。不只是生成影片，而是真正<span class=\"highlight-bold\">導演每一個畫面</span>。立即<span class=\"highlight-bold\">免費試用 Higgsfield AI</span>！",
        "tabImageToVideo": "圖生影片",
        "tabTextToVideo": "文生影片",
        "coreFeaturesTitle": "Higgsfield AI 的主要功能",
        "coreFeaturesSubtitle": "賦予每個瞬間獨特的視角",
        "cameraAwareDirectionTitle": "鏡頭感知指導",
        "cameraAwareDirectionDescription": "描述觀眾如何進入、跟隨和離開場景，而不是滿足於通用的運動效果。",
        "referenceGuidedContinuityTitle": "參考引導的連續性",
        "referenceGuidedContinuityDescription": "用圖像錨定變體，讓主體、色調和構圖保持統一的視覺風格。",
        "shortFormSceneRhythmTitle": "短影片場景節奏",
        "shortFormSceneRhythmDescription": "圍繞清晰的視覺瞬間，構思產品展示、編輯節奏和社交故事。",
        "instantFirstFrameTitle": "即時首幀生成",
        "instantFirstFrameDescription": "快速鎖定開場畫面，為整個影片建立統一的視覺基調和風格方向。",
        "imageToCinematicTitle": "圖像動畫化",
        "imageToCinematicDescription": "將靜態圖片轉化為流暢的電影級動態鏡頭，讓每一幀都充滿生命力和敘事張力。",
        "commercialTitle": "商業級輸出品質",
        "commercialDescription": "提供4K高清解析度和專業級色彩管理，滿足商業專案和品牌推廣的嚴格要求。",
        "onestopWorkflowTitle": "一站式創作工作流",
        "onestopWorkflowDescription": "從腳本到成片，整合提示詞優化、鏡頭生成、變體探索的完整創作流程。",
        "howToUseTitle": "如何使用",
        "howToUseSubtitle": "簡單三步，開始創作",
        "step1Title": "選擇 Higgsfield AI 模型",
        "step1Description": "前往<span class=\"highlight-text\">\"AI影片生成\"</span>頁面，然後在模型下拉菜單中點擊\"Higgsfield AI\"。",
        "step2Title": "定義鏡頭語言",
        "step2Description": "描述場景、動作、氛圍和你想捕捉的瞬間，或上傳參考圖片設定視覺方向。",
        "step3Title": "生成並優化",
        "step3Description": "點擊\"創建\"生成影片，對比不同版本，選擇最有說服力的鏡頭並繼續優化。",
        "youtubeTitle": "關於 Higgsfield AI 影片模型的 YouTube 影片",
        "youtubeVideosTitle": "關於 Higgsfield AI 影片模型的 YouTube 影片",
        "youtubeVideoTitle": "關於 Higgsfield AI 影片模型的 YouTube 影片",
        "xPostsTitle": "關於 Higgsfield AI 影片模型的熱門 X 帖子",
        "exploreModelsTitle": "探索其他模型",
        "sora2Title": "OpenAI Sora-2 AI 影片生成器",
        "hailuoTitle": "Hailuo AI 影片生成器",
        "klingTitle": "Kling AI 影片生成器",
        "faqTitle": "常見問題解答",
        "ctaTitle": "準備開始創作了嗎？",
        "ctaSubtitle": "立即體驗 Higgsfield AI，將您的創意轉化為電影級影片",
        "ctaDescription": "從值得追隨的鏡頭開始，將清晰的視覺指導轉化為電影感的短影片創意",
        "ctaButton": "在 WeryAI 上試用 Higgsfield AI",
        "ctaNote": "無需信用卡",
        "ctaDisclaimer": "無需信用卡",
        "videoNotSupported": "您的瀏覽器不支援影片播放",
        "videoUnsupported": "您的瀏覽器不支援影片播放",
        "videoLoadingError": "影片載入失敗",
        "videoLoadError": "影片載入失敗",
        "videoReload": "重新載入"
    },
    "pl": {
        "pageTitle": "Generator Wideo Higgsfield AI - Platforma Tworzenia Kinematograficznych Ujęć z AI",
        "pageDescription": "Doświadcz generatora wideo Higgsfield AI skoncentrowanego na kinematograficznej kontroli kamery i wizualnym opowiadaniu historii. Twórz treści wideo AI w jakości reżyserskiej z precyzyjną kontrolą kamery i wizualnym przewodnictwem. Wypróbuj za darmo na platformie WeryAI.",
        "pageKeywords": "Higgsfield AI, generator wideo AI, wideo kinematograficzne, kontrola kamery, produkcja wideo, darmowe wideo AI, WeryAI, generowanie wideo",
        "generatorTitle": "Generator Wideo Higgsfield AI",
        "generatorDescription": "WeryAI teraz głęboko integruje model Higgsfield AI. Higgsfield AI koncentruje się na <span class=\"highlight-bold\">kinematograficznej kontroli kamery</span>, umożliwiając twórcom <span class=\"highlight-bold\">precyzyjne kierowanie ruchem i językiem wizualnym każdego ujęcia</span>. Nie tylko generowanie filmów, ale naprawdę <span class=\"highlight-bold\">reżyserowanie każdej klatki</span>. <span class=\"highlight-bold\">Wypróbuj Higgsfield AI za darmo</span> teraz!",
        "tabImageToVideo": "Obraz do Wideo",
        "tabTextToVideo": "Tekst do Wideo",
        "coreFeaturesTitle": "Główne Funkcje Higgsfield AI",
        "coreFeaturesSubtitle": "Nadaj Każdemu Momentowi Punkt Widzenia",
        "cameraAwareDirectionTitle": "Kierunek Świadomy Kamery",
        "cameraAwareDirectionDescription": "Opisz, jak widz wchodzi, śledzi i opuszcza scenę zamiast zadowalać się ogólnym ruchem.",
        "referenceGuidedContinuityTitle": "Ciągłość Prowadzona przez Odniesienie",
        "referenceGuidedContinuityDescription": "Zakotwicz wariacje obrazem, aby temat, paleta i kadrowanie pozostały rozpoznawalnie Twoje.",
        "shortFormSceneRhythmTitle": "Rytm Sceny w Formacie Krótkim",
        "shortFormSceneRhythmDescription": "Opracowuj ujawnienia produktów, biaty redakcyjne i historie społeczne wokół wyraźnego momentu wizualnego.",
        "instantFirstFrameTitle": "Natychmiastowa Pierwsza Klatka",
        "instantFirstFrameDescription": "Szybko zablokuj ujęcie otwierające i ustanów jednolity ton wizualny i kierunek stylu dla całego filmu.",
        "imageToCinematicTitle": "Obraz do Kinowego",
        "imageToCinematicDescription": "Przekształć statyczne obrazy w płynne filmowe ujęcia pełne życia i napięcia narracyjnego w każdej klatce.",
        "commercialTitle": "Jakość Komercyjna",
        "commercialDescription": "Zapewnia rozdzielczość 4K wysokiej rozdzielczości i profesjonalne zarządzanie kolorami, aby spełnić rygorystyczne wymagania projektów komercyjnych i promocji marki.",
        "onestopWorkflowTitle": "Kompleksowy Przepływ Pracy Kreatywnej",
        "onestopWorkflowDescription": "Od scenariusza do ostatecznego montażu, integruje optymalizację promptów, generowanie ujęć i eksplorację wariantów w kompletny proces twórczy.",
        "howToUseTitle": "Jak Używać",
        "howToUseSubtitle": "Trzy proste kroki, aby rozpocząć",
        "step1Title": "Wybierz Model Higgsfield AI",
        "step1Description": "Przejdź do strony <span class=\"highlight-text\">„Generowanie Wideo AI\"</span>, następnie kliknij „Higgsfield AI\" w menu rozwijanym modeli.",
        "step2Title": "Zdefiniuj Język Ujęcia",
        "step2Description": "Opisz scenę, akcję, atmosferę i moment, który chcesz uchwycić, lub prześlij obraz referencyjny, aby ustawić kierunek wizualny.",
        "step3Title": "Wygeneruj i Udoskonalaj",
        "step3Description": "Kliknij „Utwórz\", aby wygenerować wideo, porównaj wersje, wybierz najbardziej przekonujące ujęcie i kontynuuj udoskonalanie.",
        "youtubeTitle": "Filmy YouTube o Modelu Wideo Higgsfield AI",
        "youtubeVideosTitle": "Filmy YouTube o Modelu Wideo Higgsfield AI",
        "youtubeVideoTitle": "Filmy YouTube o Modelu Wideo Higgsfield AI",
        "xPostsTitle": "Popularne Posty X o Modelu Wideo Higgsfield AI",
        "exploreModelsTitle": "Odkryj Inne Modele",
        "sora2Title": "Generator Wideo OpenAI Sora-2 AI",
        "hailuoTitle": "Generator Wideo Hailuo AI",
        "klingTitle": "Generator Wideo Kling AI",
        "faqTitle": "Najczęściej Zadawane Pytania",
        "ctaTitle": "Gotowy, Aby Zacząć Tworzyć?",
        "ctaSubtitle": "Doświadcz Higgsfield AI teraz i przekształć swoją kreatywność w kinematograficzne filmy",
        "ctaDescription": "Zacznij od Ujęcia, które Warto Śledzić, przekształć jasny kierunek wizualny w kinematograficzne koncepcje krótkich form",
        "ctaButton": "Wypróbuj Higgsfield AI na WeryAI",
        "ctaNote": "Nie wymaga karty kredytowej",
        "ctaDisclaimer": "Nie wymaga karty kredytowej",
        "videoNotSupported": "Twoja przeglądarka nie obsługuje odtwarzania wideo",
        "videoUnsupported": "Twoja przeglądarka nie obsługuje odtwarzania wideo",
        "videoLoadingError": "Nie udało się załadować wideo",
        "videoLoadError": "Nie udało się załadować wideo",
        "videoReload": "Załaduj ponownie"
    },
    "es": {
        "pageTitle": "Generador de Video Higgsfield AI - Plataforma de Creación de Tomas Cinematográficas con IA",
        "pageDescription": "Experimenta el generador de video Higgsfield AI enfocado en el control de cámara cinematográfico y la narrativa visual. Crea contenido de video con IA de calidad de director con dirección de cámara precisa y orientación visual. Pruébalo gratis en la plataforma WeryAI.",
        "pageKeywords": "Higgsfield AI, generador de video IA, video cinematográfico, control de cámara, producción de video, video IA gratis, WeryAI, generación de video",
        "generatorTitle": "Generador de Video Higgsfield AI",
        "generatorDescription": "WeryAI ahora integra profundamente el modelo Higgsfield AI. Higgsfield AI se enfoca en el <span class=\"highlight-bold\">control de cámara cinematográfico</span>, permitiendo a los creadores <span class=\"highlight-bold\">dirigir con precisión el movimiento y el lenguaje visual de cada toma</span>. No solo generar videos, sino verdaderamente <span class=\"highlight-bold\">dirigir cada fotograma</span>. ¡<span class=\"highlight-bold\">Prueba Higgsfield AI gratis</span> ahora!",
        "tabImageToVideo": "Imagen a Video",
        "tabTextToVideo": "Texto a Video",
        "coreFeaturesTitle": "Características Principales de Higgsfield AI",
        "coreFeaturesSubtitle": "Dale a Cada Momento un Punto de Vista",
        "cameraAwareDirectionTitle": "Dirección Consciente de Cámara",
        "cameraAwareDirectionDescription": "Describe cómo el espectador entra, sigue y deja una escena en lugar de conformarte con movimiento genérico.",
        "referenceGuidedContinuityTitle": "Continuidad Guiada por Referencia",
        "referenceGuidedContinuityDescription": "Ancla variaciones con una imagen para que el sujeto, la paleta y el encuadre se mantengan reconociblemente tuyos.",
        "shortFormSceneRhythmTitle": "Ritmo de Escena de Formato Corto",
        "shortFormSceneRhythmDescription": "Desarrolla revelaciones de productos, ritmos editoriales e historias sociales alrededor de un momento visual claro.",
        "instantFirstFrameTitle": "Primer Fotograma Instantáneo",
        "instantFirstFrameDescription": "Fija rápidamente la toma de apertura y establece un tono visual unificado y dirección de estilo para todo el video.",
        "imageToCinematicTitle": "Imagen a Cinemático",
        "imageToCinematicDescription": "Transforma imágenes estáticas en tomas cinematográficas suaves llenas de vida y tensión narrativa en cada cuadro.",
        "commercialTitle": "Calidad de Grado Comercial",
        "commercialDescription": "Ofrece resolución 4K de alta definición y gestión profesional del color para cumplir con los requisitos estrictos de proyectos comerciales y promoción de marca.",
        "onestopWorkflowTitle": "Flujo de Trabajo Creativo Todo en Uno",
        "onestopWorkflowDescription": "Desde el guion hasta el corte final, integra optimización de prompts, generación de tomas y exploración de variantes en un proceso creativo completo.",
        "howToUseTitle": "Cómo Usar",
        "howToUseSubtitle": "Tres simples pasos para comenzar",
        "step1Title": "Selecciona el Modelo Higgsfield AI",
        "step1Description": "Ve a la página <span class=\"highlight-text\">\"Generación de Video con IA\"</span>, luego haz clic en \"Higgsfield AI\" en el menú desplegable de modelos.",
        "step2Title": "Define el Lenguaje de la Toma",
        "step2Description": "Describe la escena, acción, atmósfera y momento que quieres capturar, o sube una imagen de referencia para establecer la dirección visual.",
        "step3Title": "Genera y Refina",
        "step3Description": "Haz clic en \"Crear\" para generar el video, compara versiones, selecciona la toma más convincente y continúa refinando.",
        "youtubeTitle": "Videos de YouTube sobre el Modelo de Video Higgsfield AI",
        "youtubeVideosTitle": "Videos de YouTube sobre el Modelo de Video Higgsfield AI",
        "youtubeVideoTitle": "Videos de YouTube sobre el Modelo de Video Higgsfield AI",
        "xPostsTitle": "Publicaciones Populares de X sobre el Modelo de Video Higgsfield AI",
        "exploreModelsTitle": "Explorar Otros Modelos",
        "sora2Title": "Generador de Video OpenAI Sora-2 AI",
        "hailuoTitle": "Generador de Video Hailuo AI",
        "klingTitle": "Generador de Video Kling AI",
        "faqTitle": "Preguntas Frecuentes",
        "ctaTitle": "¿Listo para Comenzar a Crear?",
        "ctaSubtitle": "Experimenta Higgsfield AI ahora y transforma tu creatividad en videos cinematográficos",
        "ctaDescription": "Comienza con una Toma que Vale la Pena Seguir, convierte la dirección visual clara en conceptos cinematográficos de formato corto",
        "ctaButton": "Prueba Higgsfield AI en WeryAI",
        "ctaNote": "No se requiere tarjeta de crédito",
        "ctaDisclaimer": "No se requiere tarjeta de crédito",
        "videoNotSupported": "Su navegador no admite la reproducción de video",
        "videoUnsupported": "Su navegador no admite la reproducción de video",
        "videoLoadingError": "Error al cargar el video",
        "videoLoadError": "Error al cargar el video",
        "videoReload": "Recargar"
    },
    "fr": {
        "pageTitle": "Générateur Vidéo Higgsfield AI - Plateforme de Création de Plans Cinématographiques avec IA",
        "pageDescription": "Découvrez le générateur vidéo Higgsfield AI axé sur le contrôle de caméra cinématographique et la narration visuelle. Créez du contenu vidéo avec IA de qualité de réalisateur avec une direction de caméra précise et des conseils visuels. Essayez-le gratuitement sur la plateforme WeryAI.",
        "pageKeywords": "Higgsfield AI, générateur vidéo IA, vidéo cinématographique, contrôle de caméra, production vidéo, vidéo IA gratuite, WeryAI, génération vidéo",
        "generatorTitle": "Générateur Vidéo Higgsfield AI",
        "generatorDescription": "WeryAI intègre désormais en profondeur le modèle Higgsfield AI. Higgsfield AI se concentre sur le <span class=\"highlight-bold\">contrôle de caméra cinématographique</span>, permettant aux créateurs de <span class=\"highlight-bold\">diriger avec précision le mouvement et le langage visuel de chaque plan</span>. Pas seulement générer des vidéos, mais vraiment <span class=\"highlight-bold\">diriger chaque image</span>. <span class=\"highlight-bold\">Essayez Higgsfield AI gratuitement</span> maintenant !",
        "tabImageToVideo": "Image vers Vidéo",
        "tabTextToVideo": "Texte vers Vidéo",
        "coreFeaturesTitle": "Fonctionnalités Principales de Higgsfield AI",
        "coreFeaturesSubtitle": "Donnez à Chaque Moment un Point de Vue",
        "cameraAwareDirectionTitle": "Direction Consciente de la Caméra",
        "cameraAwareDirectionDescription": "Décrivez comment le spectateur entre, suit et quitte une scène au lieu de se contenter d'un mouvement générique.",
        "referenceGuidedContinuityTitle": "Continuité Guidée par Référence",
        "referenceGuidedContinuityDescription": "Ancrez les variations avec une image pour que le sujet, la palette et le cadrage restent reconnaissablement vôtres.",
        "shortFormSceneRhythmTitle": "Rythme de Scène de Format Court",
        "shortFormSceneRhythmDescription": "Développez des révélations de produits, des rythmes éditoriaux et des histoires sociales autour d'un moment visuel clair.",
        "instantFirstFrameTitle": "Première Image Instantanée",
        "instantFirstFrameDescription": "Verrouillez rapidement le plan d'ouverture et établissez un ton visuel unifié et une direction de style pour toute la vidéo.",
        "imageToCinematicTitle": "Image à Cinématique",
        "imageToCinematicDescription": "Transformez des images statiques en plans cinématographiques fluides remplis de vie et de tension narrative dans chaque image.",
        "commercialTitle": "Qualité de Niveau Commercial",
        "commercialDescription": "Offre une résolution 4K haute définition et une gestion professionnelle des couleurs pour répondre aux exigences strictes des projets commerciaux et de la promotion de marque.",
        "onestopWorkflowTitle": "Flux de Travail Créatif Tout-en-Un",
        "onestopWorkflowDescription": "Du script à la coupe finale, intègre l'optimisation des prompts, la génération de plans et l'exploration de variantes dans un processus créatif complet.",
        "howToUseTitle": "Comment Utiliser",
        "howToUseSubtitle": "Trois étapes simples pour commencer",
        "step1Title": "Sélectionnez le Modèle Higgsfield AI",
        "step1Description": "Accédez à la page <span class=\"highlight-text\">« Génération Vidéo IA »</span>, puis cliquez sur « Higgsfield AI » dans le menu déroulant des modèles.",
        "step2Title": "Définissez le Langage du Plan",
        "step2Description": "Décrivez la scène, l'action, l'atmosphère et le moment que vous voulez capturer, ou téléchargez une image de référence pour définir la direction visuelle.",
        "step3Title": "Générez et Affinez",
        "step3Description": "Cliquez sur « Créer » pour générer la vidéo, comparez les versions, sélectionnez le plan le plus convaincant et continuez à affiner.",
        "youtubeTitle": "Vidéos YouTube sur le Modèle Vidéo Higgsfield AI",
        "youtubeVideosTitle": "Vidéos YouTube sur le Modèle Vidéo Higgsfield AI",
        "youtubeVideoTitle": "Vidéos YouTube sur le Modèle Vidéo Higgsfield AI",
        "xPostsTitle": "Publications X Populaires sur le Modèle Vidéo Higgsfield AI",
        "exploreModelsTitle": "Explorer d'Autres Modèles",
        "sora2Title": "Générateur Vidéo OpenAI Sora-2 AI",
        "hailuoTitle": "Générateur Vidéo Hailuo AI",
        "klingTitle": "Générateur Vidéo Kling AI",
        "faqTitle": "Questions Fréquemment Posées",
        "ctaTitle": "Prêt à Commencer à Créer ?",
        "ctaSubtitle": "Découvrez Higgsfield AI maintenant et transformez votre créativité en vidéos cinématographiques",
        "ctaDescription": "Commencez avec un Plan qui Vaut la Peine d'Être Suivi, transformez la direction visuelle claire en concepts cinématographiques de format court",
        "ctaButton": "Essayez Higgsfield AI sur WeryAI",
        "ctaNote": "Aucune carte de crédit requise",
        "ctaDisclaimer": "Aucune carte de crédit requise",
        "videoNotSupported": "Votre navigateur ne prend pas en charge la lecture vidéo",
        "videoUnsupported": "Votre navigateur ne prend pas en charge la lecture vidéo",
        "videoLoadingError": "Échec du chargement de la vidéo",
        "videoLoadError": "Échec du chargement de la vidéo",
        "videoReload": "Recharger"
    },
    "de": {
        "pageTitle": "Higgsfield AI Video Generator - KI-Kinematographische Shot-Erstellungsplattform",
        "pageDescription": "Erleben Sie den Higgsfield AI Video Generator, der sich auf kinematographische Kamerakontrolle und visuelles Storytelling konzentriert. Erstellen Sie KI-Videoinhalte in Regisseurqualität mit präziser Kameraführung und visueller Anleitung. Kostenlos auf der WeryAI-Plattform testen.",
        "pageKeywords": "Higgsfield AI, KI-Videogenerator, kinematographisches Video, Kamerakontrolle, Videoproduktion, kostenloses KI-Video, WeryAI, Videogenerierung",
        "generatorTitle": "Higgsfield AI Video Generator",
        "generatorDescription": "WeryAI integriert jetzt das Modell Higgsfield AI tiefgreifend. Higgsfield AI konzentriert sich auf <span class=\"highlight-bold\">kinematographische Kamerakontrolle</span> und ermöglicht es Erstellern, <span class=\"highlight-bold\">die Bewegung und visuelle Sprache jeder Aufnahme präzise zu steuern</span>. Nicht nur Videos generieren, sondern wirklich <span class=\"highlight-bold\">jedes Bild inszenieren</span>. <span class=\"highlight-bold\">Probieren Sie Higgsfield AI kostenlos aus</span>!",
        "tabImageToVideo": "Bild zu Video",
        "tabTextToVideo": "Text zu Video",
        "coreFeaturesTitle": "Hauptfunktionen von Higgsfield AI",
        "coreFeaturesSubtitle": "Geben Sie Jedem Moment einen Blickwinkel",
        "cameraAwareDirectionTitle": "Kamerabewusste Regie",
        "cameraAwareDirectionDescription": "Beschreiben Sie, wie der Zuschauer eine Szene betritt, verfolgt und verlässt, anstatt sich mit generischer Bewegung zufrieden zu geben.",
        "referenceGuidedContinuityTitle": "Referenzgeführte Kontinuität",
        "referenceGuidedContinuityDescription": "Verankern Sie Variationen mit einem Bild, damit das Motiv, die Palette und der Rahmen erkennbar Ihre bleiben.",
        "shortFormSceneRhythmTitle": "Kurzform-Szenenrhythmus",
        "shortFormSceneRhythmDescription": "Entwickeln Sie Produktenthüllungen, redaktionelle Beats und soziale Geschichten um einen klaren visuellen Moment.",
        "instantFirstFrameTitle": "Sofortiges Erstes Bild",
        "instantFirstFrameDescription": "Fixieren Sie schnell die Eröffnungsaufnahme und etablieren Sie einen einheitlichen visuellen Ton und eine Stilrichtung für das gesamte Video.",
        "imageToCinematicTitle": "Bild zu Kinoreif",
        "imageToCinematicDescription": "Verwandeln Sie statische Bilder in flüssige kinoreife Aufnahmen voller Leben und narrativer Spannung in jedem Frame.",
        "commercialTitle": "Kommerzielle Qualität",
        "commercialDescription": "Liefert 4K-High-Definition-Auflösung und professionelles Farbmanagement, um die strengen Anforderungen kommerzieller Projekte und Markenförderung zu erfüllen.",
        "onestopWorkflowTitle": "Alles-in-Einem-Kreativer Workflow",
        "onestopWorkflowDescription": "Vom Skript bis zum Final Cut integriert es Prompt-Optimierung, Shot-Generierung und Variantenexploration in einem vollständigen kreativen Prozess.",
        "howToUseTitle": "Verwendung",
        "howToUseSubtitle": "Drei einfache Schritte zum Einstieg",
        "step1Title": "Wählen Sie das Higgsfield AI Modell",
        "step1Description": "Gehen Sie zur Seite <span class=\"highlight-text\">„KI-Videogenerierung\"</span> und klicken Sie dann im Modell-Dropdown-Menü auf „Higgsfield AI\".",
        "step2Title": "Definieren Sie die Aufnahmesprache",
        "step2Description": "Beschreiben Sie die Szene, Aktion, Atmosphäre und den Moment, den Sie erfassen möchten, oder laden Sie ein Referenzbild hoch, um die visuelle Richtung festzulegen.",
        "step3Title": "Generieren und Verfeinern",
        "step3Description": "Klicken Sie auf „Erstellen\", um das Video zu generieren, vergleichen Sie Versionen, wählen Sie die überzeugendste Aufnahme und verfeinern Sie weiter.",
        "youtubeTitle": "YouTube-Videos über das Higgsfield AI Videomodell",
        "youtubeVideosTitle": "YouTube-Videos über das Higgsfield AI Videomodell",
        "youtubeVideoTitle": "YouTube-Videos über das Higgsfield AI Videomodell",
        "xPostsTitle": "Beliebte X-Posts über das Higgsfield AI Videomodell",
        "exploreModelsTitle": "Andere Modelle Erkunden",
        "sora2Title": "OpenAI Sora-2 AI Video Generator",
        "hailuoTitle": "Hailuo AI Video Generator",
        "klingTitle": "Kling AI Video Generator",
        "faqTitle": "Häufig Gestellte Fragen",
        "ctaTitle": "Bereit zum Erstellen?",
        "ctaSubtitle": "Erleben Sie Higgsfield AI jetzt und verwandeln Sie Ihre Kreativität in kinematographische Videos",
        "ctaDescription": "Beginnen Sie mit einer Aufnahme, die es Wert ist, Gefolgt zu Werden, verwandeln Sie klare visuelle Anweisungen in kinematographische Kurzform-Konzepte",
        "ctaButton": "Probieren Sie Higgsfield AI auf WeryAI",
        "ctaNote": "Keine Kreditkarte erforderlich",
        "ctaDisclaimer": "Keine Kreditkarte erforderlich",
        "videoNotSupported": "Ihr Browser unterstützt die Videowiedergabe nicht",
        "videoUnsupported": "Ihr Browser unterstützt die Videowiedergabe nicht",
        "videoLoadingError": "Video konnte nicht geladen werden",
        "videoLoadError": "Video konnte nicht geladen werden",
        "videoReload": "Neu laden"
    },
    "ru": {
        "pageTitle": "Генератор Видео Higgsfield AI - Платформа Создания Кинематографических Кадров с ИИ",
        "pageDescription": "Испытайте генератор видео Higgsfield AI, ориентированный на кинематографическое управление камерой и визуальное повествование. Создавайте AI видеоконтент режиссерского качества с точным управлением камерой и визуальным руководством. Попробуйте бесплатно на платформе WeryAI.",
        "pageKeywords": "Higgsfield AI, генератор видео ИИ, кинематографическое видео, управление камерой, производство видео, бесплатное видео ИИ, WeryAI, генерация видео",
        "generatorTitle": "Генератор Видео Higgsfield AI",
        "generatorDescription": "WeryAI теперь глубоко интегрировал модель Higgsfield AI. Higgsfield AI фокусируется на <span class=\"highlight-bold\">кинематографическом управлении камерой</span>, позволяя создателям <span class=\"highlight-bold\">точно управлять движением и визуальным языком каждого кадра</span>. Не просто генерировать видео, но действительно <span class=\"highlight-bold\">режиссировать каждый кадр</span>. <span class=\"highlight-bold\">Попробуйте Higgsfield AI бесплатно</span> прямо сейчас!",
        "tabImageToVideo": "Изображение в Видео",
        "tabTextToVideo": "Текст в Видео",
        "coreFeaturesTitle": "Основные Функции Higgsfield AI",
        "coreFeaturesSubtitle": "Придайте Каждому Моменту Точку Зрения",
        "cameraAwareDirectionTitle": "Камера-Осведомленная Режиссура",
        "cameraAwareDirectionDescription": "Опишите, как зритель входит, следует и покидает сцену вместо того, чтобы довольствоваться общим движением.",
        "referenceGuidedContinuityTitle": "Непрерывность на Основе Ссылки",
        "referenceGuidedContinuityDescription": "Закрепите вариации с изображением, чтобы объект, палитра и кадрирование оставались узнаваемо вашими.",
        "shortFormSceneRhythmTitle": "Ритм Короткометражной Сцены",
        "shortFormSceneRhythmDescription": "Разрабатывайте представления продуктов, редакционные биты и социальные истории вокруг четкого визуального момента.",
        "instantFirstFrameTitle": "Мгновенный Первый Кадр",
        "instantFirstFrameDescription": "Быстро зафиксируйте открывающий кадр и установите единый визуальный тон и направление стиля для всего видео.",
        "imageToCinematicTitle": "Изображение в Кинематограф",
        "imageToCinematicDescription": "Преобразуйте статические изображения в плавные кинематографические кадры, полные жизни и повествовательного напряжения в каждом кадре.",
        "commercialTitle": "Коммерческое Качество",
        "commercialDescription": "Обеспечивает разрешение 4K высокой четкости и профессиональное управление цветом для соответствия строгим требованиям коммерческих проектов и продвижения бренда.",
        "onestopWorkflowTitle": "Универсальный Творческий Рабочий Процесс",
        "onestopWorkflowDescription": "От сценария до финального монтажа, интегрирует оптимизацию промптов, генерацию кадров и исследование вариантов в полный творческий процесс.",
        "howToUseTitle": "Как Использовать",
        "howToUseSubtitle": "Три простых шага для начала",
        "step1Title": "Выберите Модель Higgsfield AI",
        "step1Description": "Перейдите на страницу <span class=\"highlight-text\">«Генерация Видео с ИИ»</span>, затем нажмите «Higgsfield AI» в выпадающем меню моделей.",
        "step2Title": "Определите Язык Кадра",
        "step2Description": "Опишите сцену, действие, атмосферу и момент, который вы хотите запечатлеть, или загрузите эталонное изображение для установки визуального направления.",
        "step3Title": "Сгенерируйте и Усовершенствуйте",
        "step3Description": "Нажмите «Создать», чтобы сгенерировать видео, сравните версии, выберите наиболее убедительный кадр и продолжайте усовершенствование.",
        "youtubeTitle": "Видео YouTube о Видеомодели Higgsfield AI",
        "youtubeVideosTitle": "Видео YouTube о Видеомодели Higgsfield AI",
        "youtubeVideoTitle": "Видео YouTube о Видеомодели Higgsfield AI",
        "xPostsTitle": "Популярные Публикации X о Видеомодели Higgsfield AI",
        "exploreModelsTitle": "Изучить Другие Модели",
        "sora2Title": "Генератор Видео OpenAI Sora-2 AI",
        "hailuoTitle": "Генератор Видео Hailuo AI",
        "klingTitle": "Генератор Видео Kling AI",
        "faqTitle": "Часто Задаваемые Вопросы",
        "ctaTitle": "Готовы Начать Создавать?",
        "ctaSubtitle": "Испытайте Higgsfield AI сейчас и превратите свое творчество в кинематографические видео",
        "ctaDescription": "Начните с Кадра, Который Стоит Следовать, превратите четкое визуальное руководство в кинематографические короткометражные концепции",
        "ctaButton": "Попробуйте Higgsfield AI на WeryAI",
        "ctaNote": "Кредитная карта не требуется",
        "ctaDisclaimer": "Кредитная карта не требуется",
        "videoNotSupported": "Ваш браузер не поддерживает воспроизведение видео",
        "videoUnsupported": "Ваш браузер не поддерживает воспроизведение видео",
        "videoLoadingError": "Не удалось загрузить видео",
        "videoLoadError": "Не удалось загрузить видео",
        "videoReload": "Перезагрузить"
    },
    "pt": {
        "pageTitle": "Gerador de Vídeo Higgsfield AI - Plataforma de Criação de Planos Cinematográficos com IA",
        "pageDescription": "Experimente o gerador de vídeo Higgsfield AI focado no controle de câmera cinematográfico e narrativa visual. Crie conteúdo de vídeo com IA de qualidade de diretor com controle de câmera preciso e orientação visual. Experimente gratuitamente na plataforma WeryAI.",
        "pageKeywords": "Higgsfield AI, gerador de vídeo IA, vídeo cinematográfico, controle de câmera, produção de vídeo, vídeo IA grátis, WeryAI, geração de vídeo",
        "generatorTitle": "Gerador de Vídeo Higgsfield AI",
        "generatorDescription": "O WeryAI agora integra profundamente o modelo Higgsfield AI. Higgsfield AI se concentra no <span class=\"highlight-bold\">controle de câmera cinematográfico</span>, permitindo aos criadores <span class=\"highlight-bold\">dirigir com precisão o movimento e a linguagem visual de cada tomada</span>. Não apenas gerar vídeos, mas realmente <span class=\"highlight-bold\">dirigir cada quadro</span>. <span class=\"highlight-bold\">Experimente o Higgsfield AI gratuitamente</span> agora!",
        "tabImageToVideo": "Imagem para Vídeo",
        "tabTextToVideo": "Texto para Vídeo",
        "coreFeaturesTitle": "Principais Recursos do Higgsfield AI",
        "coreFeaturesSubtitle": "Dê a Cada Momento um Ponto de Vista",
        "cameraAwareDirectionTitle": "Direção Consciente da Câmera",
        "cameraAwareDirectionDescription": "Descreva como o espectador entra, segue e deixa uma cena em vez de se contentar com movimento genérico.",
        "referenceGuidedContinuityTitle": "Continuidade Guiada por Referência",
        "referenceGuidedContinuityDescription": "Ancore variações com uma imagem para que o assunto, a paleta e o enquadramento permaneçam reconhecivelmente seus.",
        "shortFormSceneRhythmTitle": "Ritmo de Cena de Formato Curto",
        "shortFormSceneRhythmDescription": "Desenvolva revelações de produtos, batidas editoriais e histórias sociais em torno de um momento visual claro.",
        "instantFirstFrameTitle": "Primeiro Quadro Instantâneo",
        "instantFirstFrameDescription": "Fixe rapidamente a tomada de abertura e estabeleça um tom visual unificado e direção de estilo para todo o vídeo.",
        "imageToCinematicTitle": "Imagem para Cinemático",
        "imageToCinematicDescription": "Transforme imagens estáticas em tomadas cinematográficas suaves cheias de vida e tensão narrativa em cada quadro.",
        "commercialTitle": "Qualidade de Nível Comercial",
        "commercialDescription": "Oferece resolução 4K de alta definição e gerenciamento profissional de cores para atender aos requisitos rigorosos de projetos comerciais e promoção de marca.",
        "onestopWorkflowTitle": "Fluxo de Trabalho Criativo Completo",
        "onestopWorkflowDescription": "Do roteiro ao corte final, integra otimização de prompts, geração de tomadas e exploração de variantes em um processo criativo completo.",
        "howToUseTitle": "Como Usar",
        "howToUseSubtitle": "Três passos simples para começar",
        "step1Title": "Selecione o Modelo Higgsfield AI",
        "step1Description": "Vá para a página <span class=\"highlight-text\">\"Geração de Vídeo com IA\"</span>, depois clique em \"Higgsfield AI\" no menu suspenso de modelos.",
        "step2Title": "Defina a Linguagem da Tomada",
        "step2Description": "Descreva a cena, ação, atmosfera e momento que você deseja capturar, ou carregue uma imagem de referência para definir a direção visual.",
        "step3Title": "Gere e Refine",
        "step3Description": "Clique em \"Criar\" para gerar o vídeo, compare versões, selecione a tomada mais convincente e continue refinando.",
        "youtubeTitle": "Vídeos do YouTube Sobre o Modelo de Vídeo Higgsfield AI",
        "youtubeVideosTitle": "Vídeos do YouTube Sobre o Modelo de Vídeo Higgsfield AI",
        "youtubeVideoTitle": "Vídeos do YouTube Sobre o Modelo de Vídeo Higgsfield AI",
        "xPostsTitle": "Publicações Populares do X Sobre o Modelo de Vídeo Higgsfield AI",
        "exploreModelsTitle": "Explorar Outros Modelos",
        "sora2Title": "Gerador de Vídeo OpenAI Sora-2 AI",
        "hailuoTitle": "Gerador de Vídeo Hailuo AI",
        "klingTitle": "Gerador de Vídeo Kling AI",
        "faqTitle": "Perguntas Frequentes",
        "ctaTitle": "Pronto para Começar a Criar?",
        "ctaSubtitle": "Experimente o Higgsfield AI agora e transforme sua criatividade em vídeos cinematográficos",
        "ctaDescription": "Comece com uma Tomada que Vale a Pena Seguir, transforme a direção visual clara em conceitos cinematográficos de formato curto",
        "ctaButton": "Experimente o Higgsfield AI no WeryAI",
        "ctaNote": "Nenhum cartão de crédito necessário",
        "ctaDisclaimer": "Nenhum cartão de crédito necessário",
        "videoNotSupported": "Seu navegador não suporta reprodução de vídeo",
        "videoUnsupported": "Seu navegador não suporta reprodução de vídeo",
        "videoLoadingError": "Falha ao carregar o vídeo",
        "videoLoadError": "Falha ao carregar o vídeo",
        "videoReload": "Recarregar"
    },
    "it": {
        "pageTitle": "Generatore Video Higgsfield AI - Piattaforma di Creazione di Riprese Cinematografiche con IA",
        "pageDescription": "Sperimenta il generatore video Higgsfield AI focalizzato sul controllo della telecamera cinematografico e sulla narrazione visiva. Crea contenuti video con IA di qualità da regista con controllo della telecamera preciso e guida visiva. Provalo gratuitamente sulla piattaforma WeryAI.",
        "pageKeywords": "Higgsfield AI, generatore video IA, video cinematografico, controllo della telecamera, produzione video, video IA gratuito, WeryAI, generazione video",
        "generatorTitle": "Generatore Video Higgsfield AI",
        "generatorDescription": "WeryAI integra ora in profondità il modello Higgsfield AI. Higgsfield AI si concentra sul <span class=\"highlight-bold\">controllo della telecamera cinematografico</span>, consentendo ai creatori di <span class=\"highlight-bold\">dirigere con precisione il movimento e il linguaggio visivo di ogni ripresa</span>. Non solo generare video, ma davvero <span class=\"highlight-bold\">dirigere ogni fotogramma</span>. <span class=\"highlight-bold\">Prova Higgsfield AI gratuitamente</span> ora!",
        "tabImageToVideo": "Immagine a Video",
        "tabTextToVideo": "Testo a Video",
        "coreFeaturesTitle": "Funzionalità Principali di Higgsfield AI",
        "coreFeaturesSubtitle": "Dai a Ogni Momento un Punto di Vista",
        "cameraAwareDirectionTitle": "Direzione Consapevole della Telecamera",
        "cameraAwareDirectionDescription": "Descrivi come lo spettatore entra, segue e lascia una scena invece di accontentarsi di un movimento generico.",
        "referenceGuidedContinuityTitle": "Continuità Guidata dal Riferimento",
        "referenceGuidedContinuityDescription": "Ancora le variazioni con un'immagine in modo che il soggetto, la tavolozza e l'inquadratura rimangano riconoscibilmente tuoi.",
        "shortFormSceneRhythmTitle": "Ritmo della Scena in Formato Breve",
        "shortFormSceneRhythmDescription": "Sviluppa rivelazioni di prodotti, battiti editoriali e storie sociali attorno a un momento visivo chiaro.",
        "instantFirstFrameTitle": "Primo Fotogramma Istantaneo",
        "instantFirstFrameDescription": "Fissa rapidamente la ripresa di apertura e stabilisci un tono visivo unificato e una direzione di stile per l'intero video.",
        "imageToCinematicTitle": "Immagine a Cinematico",
        "imageToCinematicDescription": "Trasforma immagini statiche in riprese cinematografiche fluide piene di vita e tensione narrativa in ogni fotogramma.",
        "commercialTitle": "Qualità di Livello Commerciale",
        "commercialDescription": "Offre risoluzione 4K ad alta definizione e gestione professionale dei colori per soddisfare i rigorosi requisiti di progetti commerciali e promozione del brand.",
        "onestopWorkflowTitle": "Flusso di Lavoro Creativo Tutto-in-Uno",
        "onestopWorkflowDescription": "Dallo script al montaggio finale, integra ottimizzazione dei prompt, generazione di riprese ed esplorazione di varianti in un processo creativo completo.",
        "howToUseTitle": "Come Usare",
        "howToUseSubtitle": "Tre semplici passaggi per iniziare",
        "step1Title": "Seleziona il Modello Higgsfield AI",
        "step1Description": "Vai alla pagina <span class=\"highlight-text\">\"Generazione Video con IA\"</span>, quindi fai clic su \"Higgsfield AI\" nel menu a discesa dei modelli.",
        "step2Title": "Definisci il Linguaggio della Ripresa",
        "step2Description": "Descrivi la scena, l'azione, l'atmosfera e il momento che vuoi catturare, o carica un'immagine di riferimento per impostare la direzione visiva.",
        "step3Title": "Genera e Affina",
        "step3Description": "Fai clic su \"Crea\" per generare il video, confronta le versioni, seleziona la ripresa più convincente e continua a perfezionare.",
        "youtubeTitle": "Video YouTube sul Modello Video Higgsfield AI",
        "youtubeVideosTitle": "Video YouTube sul Modello Video Higgsfield AI",
        "youtubeVideoTitle": "Video YouTube sul Modello Video Higgsfield AI",
        "xPostsTitle": "Post X Popolari sul Modello Video Higgsfield AI",
        "exploreModelsTitle": "Esplora Altri Modelli",
        "sora2Title": "Generatore Video OpenAI Sora-2 AI",
        "hailuoTitle": "Generatore Video Hailuo AI",
        "klingTitle": "Generatore Video Kling AI",
        "faqTitle": "Domande Frequenti",
        "ctaTitle": "Pronto per Iniziare a Creare?",
        "ctaSubtitle": "Sperimenta Higgsfield AI ora e trasforma la tua creatività in video cinematografici",
        "ctaDescription": "Inizia con una Ripresa che Vale la Pena Seguire, trasforma la direzione visiva chiara in concetti cinematografici in formato breve",
        "ctaButton": "Prova Higgsfield AI su WeryAI",
        "ctaNote": "Nessuna carta di credito richiesta",
        "ctaDisclaimer": "Nessuna carta di credito richiesta",
        "videoNotSupported": "Il tuo browser non supporta la riproduzione video",
        "videoUnsupported": "Il tuo browser non supporta la riproduzione video",
        "videoLoadingError": "Caricamento video fallito",
        "videoLoadError": "Caricamento video fallito",
        "videoReload": "Ricarica"
    },
    "ar": {
        "pageTitle": "Higgsfield AI لإنشاء الفيديو - منصة إنتاج لقطات سينمائية بالذكاء الاصطناعي",
        "pageDescription": "اكتشف مولد الفيديوهات بالذكاء الاصطناعي Higgsfield، المخصص للتحكم في لقطات على مستوى الأفلام والسرد البصري. من خلال جدولة دقيقة للقطات وتوجيه بصري، يمكنك إنشاء محتوى فيديو بالذكاء الاصطناعي يتمتع بإحساس الإخراج. جربه مجانًا على منصة WeryAI.",
        "pageKeywords": "Higgsfield AI، مولد فيديو بالذكاء الاصطناعي، فيديو بمستوى سينمائي، التحكم بالكاميرا، إنتاج الفيديو، فيديو بالذكاء الاصطناعي مجاني، WeryAI، توليد الفيديو",
        "generatorTitle": "مولّد الفيديوهات Higgsfield AI",
        "generatorDescription": "<span class=\"highlight-bold\">WeryAI الآن مدمج بعمق مع نموذج Higgsfield AI. يركز Higgsfield AI على التحكم بمستوى سينمائي في اللقطات، مما يمكّن المبدعين من توجيه حركة كل لقطة ولغة الصورة بدقة. ليس فقط إنتاج الفيديو، بل إخراج كل مشهد فعليًا. جرب Higgsfield AI مجانًا الآن!</span>",
        "tabImageToVideo": "إنشاء الفيديو من الصور",
        "tabTextToVideo": "فيديو ون شنج",
        "coreFeaturesTitle": "الوظائف الرئيسية لـ Higgsfield AI",
        "coreFeaturesSubtitle": "منح كل لحظة منظورًا فريدًا",
        "cameraAwareDirectionTitle": "توجيه إدراك الكاميرا",
        "cameraAwareDirectionDescription": "وصف كيفية دخول الجمهور ومتابعته ومغادرته للمشهد، بدلاً من الاكتفاء بالتأثير الحركي العام.",
        "referenceGuidedContinuityTitle": "استمرارية مستوحاة من التوجيه",
        "referenceGuidedContinuityDescription": "استخدم الصور لتثبيت المتغيرات، بحيث يحافظ الموضوع ونبرة اللون والتركيب على أسلوب بصري موحد.",
        "shortFormSceneRhythmTitle": "إيقاع مشهد الفيديو القصير",
        "shortFormSceneRhythmDescription": "ركز على اللحظات البصرية الواضحة عند تخطيط عرض المنتج وإيقاع التحرير والقصص الاجتماعية.",
        "instantFirstFrameTitle": "توليد الإطار الأول الفوري",
        "instantFirstFrameDescription": "تثبيت الشاشة الافتتاحية بسرعة، لإنشاء توجه بصري موحد ونمط للفيديو بأكمله.",
        "imageToCinematicTitle": "تحريك الصور",
        "imageToCinematicDescription": "تحويل الصور الثابتة إلى لقطات ديناميكية سلسة بمستوى أفلام سينمائية، مما يجعل كل إطار مليئًا بالحياة والقوة السردية.",
        "commercialTitle": "جودة إخراج تجارية",
        "commercialDescription": "توفر دقة 4K فائقة الجودة وإدارة ألوان احترافية لتلبية متطلبات المشاريع التجارية والترويج للعلامات التجارية الصارمة.",
        "onestopWorkflowTitle": "تدفق العمل الإبداعي المتكامل",
        "onestopWorkflowDescription": "من النص البرمجي إلى المنتج النهائي، دمج تحسين كلمات الإرشاد، إنشاء اللقطات، واستكشاف المتغيرات في عملية إبداعية كاملة.",
        "howToUseTitle": "كيفية الاستخدام",
        "howToUseSubtitle": "ثلاث خطوات بسيطة، ابدأ بالإبداع",
        "step1Title": "اختر نموذج Higgsfield AI",
        "step1Description": "<span class=\"highlight-text\">انتقل إلى صفحة \"توليد الفيديو بالذكاء الاصطناعي\"، ثم انقر على \"Higgsfield AI\" في قائمة النماذج المنسدلة.</span>",
        "step2Title": "تعريف لغة اللقطة",
        "step2Description": "وصف المشهد، والحركة، والأجواء، واللحظة التي تريد التقاطها، أو تحميل صورة مرجعية لتحديد الاتجاه البصري.",
        "step3Title": "إنشاء وتحسين",
        "step3Description": "انقر على \"إنشاء\" لإنشاء الفيديو، قارن بين الإصدارات المختلفة، اختر اللقطات الأكثر إقناعًا واستمر في تحسينها.",
        "youtubeTitle": "حول مقاطع فيديو نموذج Higgsfield AI على يوتيوب",
        "youtubeVideosTitle": "حول مقاطع فيديو نموذج Higgsfield AI على يوتيوب",
        "youtubeVideoTitle": "حول مقاطع فيديو نموذج Higgsfield AI على يوتيوب",
        "xPostsTitle": "حول منشورات X الشائعة لنموذج الفيديو Higgsfield AI",
        "exploreModelsTitle": "استكشاف نماذج أخرى",
        "sora2Title": "مولد الفيديو بالذكاء الاصطناعي OpenAI Sora-2",
        "hailuoTitle": "مولّد الفيديو Hailuo AI",
        "klingTitle": "مولد فيديو Kling AI",
        "faqTitle": "الأسئلة الشائعة",
        "ctaTitle": "هل أنت مستعد للبدء في الإبداع؟",
        "ctaSubtitle": "جرب Higgsfield AI فورًا وحوّل إبداعاتك إلى فيديوهات بمستوى سينمائي",
        "ctaDescription": "ابدأ بلقطات تستحق المتابعة، حوّل الإرشادات البصرية الواضحة إلى أفكار مقاطع فيديو قصيرة ذات طابع سينمائي",
        "ctaButton": "جرب Higgsfield AI على WeryAI",
        "ctaNote": "لا حاجة لبطاقة ائتمان",
        "ctaDisclaimer": "لا حاجة لبطاقة ائتمان",
        "videoNotSupported": "متصفحك لا يدعم تشغيل الفيديو",
        "videoUnsupported": "متصفحك لا يدعم تشغيل الفيديو",
        "videoLoadingError": "فشل تحميل الفيديو",
        "videoLoadError": "فشل تحميل الفيديو",
        "videoReload": "إعادة تحميل"
    },
    "th": {
        "pageTitle": "Higgsfield AI Video Generator",
        "pageDescription": "สร้างวิดีโอด้วย Higgsfield AI",
        "pageKeywords": "Higgsfield AI, video, AI",
        "generatorTitle": "Higgsfield AI",
        "generatorDescription": "WeryAI รวม Higgsfield AI",
        "tabImageToVideo": "รูปเป็นวิดีโอ",
        "tabTextToVideo": "ข้อความเป็นวิดีโอ",
        "coreFeaturesTitle": "คุณสมบัติหลัก",
        "coreFeaturesSubtitle": "สร้างคอนเทนต์ AI คุณภาพสูงด้วย Higgsfield AI บน WeryAI",
        "cameraAwareDirectionTitle": "การควบคุมกล้อง",
        "cameraAwareDirectionDescription": "อธิบายฉาก",
        "referenceGuidedContinuityTitle": "ความต่อเนื่อง",
        "referenceGuidedContinuityDescription": "ยึดรูปแบบ",
        "shortFormSceneRhythmTitle": "จังหวะฉาก",
        "shortFormSceneRhythmDescription": "คิดค้นการแสดง",
        "instantFirstFrameTitle": "ความสามารถหลัก",
        "instantFirstFrameDescription": "สร้างคอนเทนต์ AI คุณภาพสูงด้วย Higgsfield AI บน WeryAI",
        "imageToCinematicTitle": "ความสามารถหลัก",
        "imageToCinematicDescription": "สร้างคอนเทนต์ AI คุณภาพสูงด้วย Higgsfield AI บน WeryAI",
        "commercialTitle": "ความสามารถหลัก",
        "commercialDescription": "สร้างคอนเทนต์ AI คุณภาพสูงด้วย Higgsfield AI บน WeryAI",
        "onestopWorkflowTitle": "ความสามารถหลัก",
        "onestopWorkflowDescription": "สร้างคอนเทนต์ AI คุณภาพสูงด้วย Higgsfield AI บน WeryAI",
        "howToUseTitle": "วิธีใช้",
        "howToUseSubtitle": "สร้างคอนเทนต์ AI คุณภาพสูงด้วย Higgsfield AI บน WeryAI",
        "step1Title": "เลือกโมเดล",
        "step1Description": "เลือก Higgsfield",
        "step2Title": "ใส่คำอธิบาย",
        "step2Description": "อธิบายฉาก",
        "step3Title": "สร้าง",
        "step3Description": "คลิกสร้าง",
        "youtubeTitle": "YouTube",
        "youtubeVideosTitle": "ความสามารถหลัก",
        "youtubeVideoTitle": "ความสามารถหลัก",
        "xPostsTitle": "X Posts",
        "exploreModelsTitle": "โมเดลอื่นๆ",
        "sora2Title": "Sora-2",
        "hailuoTitle": "Hailuo",
        "klingTitle": "Kling",
        "faqTitle": "คำถาม",
        "ctaTitle": "พร้อม?",
        "ctaSubtitle": "สร้างคอนเทนต์ AI คุณภาพสูงด้วย Higgsfield AI บน WeryAI",
        "ctaDescription": "เริ่มเลย",
        "ctaButton": "ลองใช้",
        "ctaNote": "สร้างคอนเทนต์ AI คุณภาพสูงด้วย Higgsfield AI บน WeryAI",
        "ctaDisclaimer": "ไม่ต้องการบัตร",
        "videoNotSupported": "ไม่รองรับ",
        "videoUnsupported": "สร้างคอนเทนต์ AI คุณภาพสูงด้วย Higgsfield AI บน WeryAI",
        "videoLoadingError": "สร้างคอนเทนต์ AI คุณภาพสูงด้วย Higgsfield AI บน WeryAI",
        "videoLoadError": "โหลดผิดพลาด",
        "videoReload": "โหลดใหม่"
    },
    "da": {
        "pageTitle": "Higgsfield AI Video Generator",
        "pageDescription": "Opret videoer med Higgsfield AI",
        "pageKeywords": "Higgsfield AI, video, AI",
        "generatorTitle": "Higgsfield AI",
        "generatorDescription": "WeryAI integrerer Higgsfield AI",
        "tabImageToVideo": "Billede til Video",
        "tabTextToVideo": "Tekst til Video",
        "coreFeaturesTitle": "Hovedfunktioner",
        "coreFeaturesSubtitle": "Opret AI-indhold i høj kvalitet med Higgsfield AI på WeryAI.",
        "cameraAwareDirectionTitle": "Kamerakontrol",
        "cameraAwareDirectionDescription": "Beskriv scenen",
        "referenceGuidedContinuityTitle": "Kontinuitet",
        "referenceGuidedContinuityDescription": "Ankre varianter",
        "shortFormSceneRhythmTitle": "Scenerhythm",
        "shortFormSceneRhythmDescription": "Konceptualiser shows",
        "instantFirstFrameTitle": "Kernefunktion",
        "instantFirstFrameDescription": "Opret AI-indhold i høj kvalitet med Higgsfield AI på WeryAI.",
        "imageToCinematicTitle": "Kernefunktion",
        "imageToCinematicDescription": "Opret AI-indhold i høj kvalitet med Higgsfield AI på WeryAI.",
        "commercialTitle": "Kernefunktion",
        "commercialDescription": "Opret AI-indhold i høj kvalitet med Higgsfield AI på WeryAI.",
        "onestopWorkflowTitle": "Kernefunktion",
        "onestopWorkflowDescription": "Opret AI-indhold i høj kvalitet med Higgsfield AI på WeryAI.",
        "howToUseTitle": "Sådan bruges",
        "howToUseSubtitle": "Opret AI-indhold i høj kvalitet med Higgsfield AI på WeryAI.",
        "step1Title": "Vælg model",
        "step1Description": "Vælg Higgsfield",
        "step2Title": "Indtast beskrivelse",
        "step2Description": "Beskriv scenen",
        "step3Title": "Generer",
        "step3Description": "Klik generer",
        "youtubeTitle": "YouTube",
        "youtubeVideosTitle": "Kernefunktion",
        "youtubeVideoTitle": "Kernefunktion",
        "xPostsTitle": "X Opslag",
        "exploreModelsTitle": "Udforsk andre modeller",
        "sora2Title": "Sora-2",
        "hailuoTitle": "Hailuo",
        "klingTitle": "Kling",
        "faqTitle": "FAQ",
        "ctaTitle": "Klar?",
        "ctaSubtitle": "Opret AI-indhold i høj kvalitet med Higgsfield AI på WeryAI.",
        "ctaDescription": "Start nu",
        "ctaButton": "Prøv",
        "ctaNote": "Opret AI-indhold i høj kvalitet med Higgsfield AI på WeryAI.",
        "ctaDisclaimer": "Intet kort",
        "videoNotSupported": "Ikke understøttet",
        "videoUnsupported": "Opret AI-indhold i høj kvalitet med Higgsfield AI på WeryAI.",
        "videoLoadingError": "Opret AI-indhold i høj kvalitet med Higgsfield AI på WeryAI.",
        "videoLoadError": "Indlæsningsfejl",
        "videoReload": "Genindlæs"
    },
    "no": {
        "pageTitle": "Higgsfield AI Video Generator",
        "pageDescription": "Opprett videoer med Higgsfield AI",
        "pageKeywords": "Higgsfield AI, video, AI",
        "generatorTitle": "Higgsfield AI",
        "generatorDescription": "WeryAI integrerer Higgsfield AI",
        "tabImageToVideo": "Bilde til Video",
        "tabTextToVideo": "Tekst til Video",
        "coreFeaturesTitle": "Hovedfunksjoner",
        "coreFeaturesSubtitle": "Lag AI-innhold av høy kvalitet med Higgsfield AI på WeryAI.",
        "cameraAwareDirectionTitle": "Kamerakontroll",
        "cameraAwareDirectionDescription": "Beskriv scenen",
        "referenceGuidedContinuityTitle": "Kontinuitet",
        "referenceGuidedContinuityDescription": "Forankre varianter",
        "shortFormSceneRhythmTitle": "Scenerhythm",
        "shortFormSceneRhythmDescription": "Konseptualisere show",
        "instantFirstFrameTitle": "Kjernefunksjon",
        "instantFirstFrameDescription": "Lag AI-innhold av høy kvalitet med Higgsfield AI på WeryAI.",
        "imageToCinematicTitle": "Kjernefunksjon",
        "imageToCinematicDescription": "Lag AI-innhold av høy kvalitet med Higgsfield AI på WeryAI.",
        "commercialTitle": "Kjernefunksjon",
        "commercialDescription": "Lag AI-innhold av høy kvalitet med Higgsfield AI på WeryAI.",
        "onestopWorkflowTitle": "Kjernefunksjon",
        "onestopWorkflowDescription": "Lag AI-innhold av høy kvalitet med Higgsfield AI på WeryAI.",
        "howToUseTitle": "Slik bruker du",
        "howToUseSubtitle": "Lag AI-innhold av høy kvalitet med Higgsfield AI på WeryAI.",
        "step1Title": "Velg modell",
        "step1Description": "Velg Higgsfield",
        "step2Title": "Skriv inn beskrivelse",
        "step2Description": "Beskriv scenen",
        "step3Title": "Generer",
        "step3Description": "Klikk generer",
        "youtubeTitle": "YouTube",
        "youtubeVideosTitle": "Kjernefunksjon",
        "youtubeVideoTitle": "Kjernefunksjon",
        "xPostsTitle": "X Innlegg",
        "exploreModelsTitle": "Utforsk andre modeller",
        "sora2Title": "Sora-2",
        "hailuoTitle": "Hailuo",
        "klingTitle": "Kling",
        "faqTitle": "FAQ",
        "ctaTitle": "Klar?",
        "ctaSubtitle": "Lag AI-innhold av høy kvalitet med Higgsfield AI på WeryAI.",
        "ctaDescription": "Start nå",
        "ctaButton": "Prøv",
        "ctaNote": "Lag AI-innhold av høy kvalitet med Higgsfield AI på WeryAI.",
        "ctaDisclaimer": "Inget kort",
        "videoNotSupported": "Ikke støttet",
        "videoUnsupported": "Lag AI-innhold av høy kvalitet med Higgsfield AI på WeryAI.",
        "videoLoadingError": "Lag AI-innhold av høy kvalitet med Higgsfield AI på WeryAI.",
        "videoLoadError": "Lastingsfeil",
        "videoReload": "Last inn på nytt"
    },
    "nl": {
        "pageTitle": "Higgsfield AI Video Generator",
        "pageDescription": "Maak video's met Higgsfield AI",
        "pageKeywords": "Higgsfield AI, video, AI",
        "generatorTitle": "Higgsfield AI",
        "generatorDescription": "WeryAI integreert Higgsfield AI",
        "tabImageToVideo": "Afbeelding naar Video",
        "tabTextToVideo": "Tekst naar Video",
        "coreFeaturesTitle": "Hoofdfuncties",
        "coreFeaturesSubtitle": "Maak hoogwaardige AI-content met Higgsfield AI op WeryAI.",
        "cameraAwareDirectionTitle": "Camerabesturing",
        "cameraAwareDirectionDescription": "Beschrijf de scène",
        "referenceGuidedContinuityTitle": "Continuïteit",
        "referenceGuidedContinuityDescription": "Varianten verankeren",
        "shortFormSceneRhythmTitle": "Scèneritme",
        "shortFormSceneRhythmDescription": "Conceptualiseer shows",
        "instantFirstFrameTitle": "Kernfunctie",
        "instantFirstFrameDescription": "Maak hoogwaardige AI-content met Higgsfield AI op WeryAI.",
        "imageToCinematicTitle": "Kernfunctie",
        "imageToCinematicDescription": "Maak hoogwaardige AI-content met Higgsfield AI op WeryAI.",
        "commercialTitle": "Kernfunctie",
        "commercialDescription": "Maak hoogwaardige AI-content met Higgsfield AI op WeryAI.",
        "onestopWorkflowTitle": "Kernfunctie",
        "onestopWorkflowDescription": "Maak hoogwaardige AI-content met Higgsfield AI op WeryAI.",
        "howToUseTitle": "Hoe te gebruiken",
        "howToUseSubtitle": "Maak hoogwaardige AI-content met Higgsfield AI op WeryAI.",
        "step1Title": "Selecteer model",
        "step1Description": "Selecteer Higgsfield",
        "step2Title": "Voer beschrijving in",
        "step2Description": "Beschrijf de scène",
        "step3Title": "Genereer",
        "step3Description": "Klik genereren",
        "youtubeTitle": "YouTube",
        "youtubeVideosTitle": "Kernfunctie",
        "youtubeVideoTitle": "Kernfunctie",
        "xPostsTitle": "X Berichten",
        "exploreModelsTitle": "Verken andere modellen",
        "sora2Title": "Sora-2",
        "hailuoTitle": "Hailuo",
        "klingTitle": "Kling",
        "faqTitle": "FAQ",
        "ctaTitle": "Klaar?",
        "ctaSubtitle": "Maak hoogwaardige AI-content met Higgsfield AI op WeryAI.",
        "ctaDescription": "Begin nu",
        "ctaButton": "Probeer",
        "ctaNote": "Maak hoogwaardige AI-content met Higgsfield AI op WeryAI.",
        "ctaDisclaimer": "Geen kaart",
        "videoNotSupported": "Niet ondersteund",
        "videoUnsupported": "Maak hoogwaardige AI-content met Higgsfield AI op WeryAI.",
        "videoLoadingError": "Maak hoogwaardige AI-content met Higgsfield AI op WeryAI.",
        "videoLoadError": "Laadout",
        "videoReload": "Herladen"
    },
    "id": {
        "pageTitle": "Higgsfield AI Video Generator",
        "pageDescription": "Buat video dengan Higgsfield AI",
        "pageKeywords": "Higgsfield AI, video, AI",
        "generatorTitle": "Higgsfield AI",
        "generatorDescription": "WeryAI mengintegrasikan Higgsfield AI",
        "tabImageToVideo": "Gambar ke Video",
        "tabTextToVideo": "Teks ke Video",
        "coreFeaturesTitle": "Fitur Utama",
        "coreFeaturesSubtitle": "Buat konten AI berkualitas tinggi dengan Higgsfield AI di WeryAI.",
        "cameraAwareDirectionTitle": "Kontrol Kamera",
        "cameraAwareDirectionDescription": "Jelaskan adegan",
        "referenceGuidedContinuityTitle": "Kontinuitas",
        "referenceGuidedContinuityDescription": "Jangkar varian",
        "shortFormSceneRhythmTitle": "Ritme Adegan",
        "shortFormSceneRhythmDescription": "Konseptualisasikan pertunjukan",
        "instantFirstFrameTitle": "Fitur utama",
        "instantFirstFrameDescription": "Buat konten AI berkualitas tinggi dengan Higgsfield AI di WeryAI.",
        "imageToCinematicTitle": "Fitur utama",
        "imageToCinematicDescription": "Buat konten AI berkualitas tinggi dengan Higgsfield AI di WeryAI.",
        "commercialTitle": "Fitur utama",
        "commercialDescription": "Buat konten AI berkualitas tinggi dengan Higgsfield AI di WeryAI.",
        "onestopWorkflowTitle": "Fitur utama",
        "onestopWorkflowDescription": "Buat konten AI berkualitas tinggi dengan Higgsfield AI di WeryAI.",
        "howToUseTitle": "Cara Menggunakan",
        "howToUseSubtitle": "Buat konten AI berkualitas tinggi dengan Higgsfield AI di WeryAI.",
        "step1Title": "Pilih model",
        "step1Description": "Pilih Higgsfield",
        "step2Title": "Masukkan deskripsi",
        "step2Description": "Jelaskan adegan",
        "step3Title": "Hasilkan",
        "step3Description": "Klik hasilkan",
        "youtubeTitle": "YouTube",
        "youtubeVideosTitle": "Fitur utama",
        "youtubeVideoTitle": "Fitur utama",
        "xPostsTitle": "Posting X",
        "exploreModelsTitle": "Jelajahi model lain",
        "sora2Title": "Sora-2",
        "hailuoTitle": "Hailuo",
        "klingTitle": "Kling",
        "faqTitle": "FAQ",
        "ctaTitle": "Siap?",
        "ctaSubtitle": "Buat konten AI berkualitas tinggi dengan Higgsfield AI di WeryAI.",
        "ctaDescription": "Mulai sekarang",
        "ctaButton": "Coba",
        "ctaNote": "Buat konten AI berkualitas tinggi dengan Higgsfield AI di WeryAI.",
        "ctaDisclaimer": "Tanpa kartu",
        "videoNotSupported": "Tidak didukung",
        "videoUnsupported": "Buat konten AI berkualitas tinggi dengan Higgsfield AI di WeryAI.",
        "videoLoadingError": "Buat konten AI berkualitas tinggi dengan Higgsfield AI di WeryAI.",
        "videoLoadError": "Kesalahan memuat",
        "videoReload": "Muat ulang"
    },
    "tr": {
        "pageTitle": "Higgsfield AI Video Generator",
        "pageDescription": "Higgsfield AI ile video oluşturun",
        "pageKeywords": "Higgsfield AI, video, AI",
        "generatorTitle": "Higgsfield AI",
        "generatorDescription": "WeryAI, Higgsfield AI'yi entegre ediyor",
        "tabImageToVideo": "Resimden Videoya",
        "tabTextToVideo": "Metinden Videoya",
        "coreFeaturesTitle": "Ana Özellikler",
        "coreFeaturesSubtitle": "WeryAI üzerinde Higgsfield AI ile yüksek kaliteli AI içeriği oluşturun.",
        "cameraAwareDirectionTitle": "Kamera Kontrolü",
        "cameraAwareDirectionDescription": "Sahneyi açıklayın",
        "referenceGuidedContinuityTitle": "Süreklilik",
        "referenceGuidedContinuityDescription": "Varyantları sabitleyin",
        "shortFormSceneRhythmTitle": "Sahne Ritmi",
        "shortFormSceneRhythmDescription": "Gösterileri kavramsallaştırın",
        "instantFirstFrameTitle": "Temel özellik",
        "instantFirstFrameDescription": "WeryAI üzerinde Higgsfield AI ile yüksek kaliteli AI içeriği oluşturun.",
        "imageToCinematicTitle": "Temel özellik",
        "imageToCinematicDescription": "WeryAI üzerinde Higgsfield AI ile yüksek kaliteli AI içeriği oluşturun.",
        "commercialTitle": "Temel özellik",
        "commercialDescription": "WeryAI üzerinde Higgsfield AI ile yüksek kaliteli AI içeriği oluşturun.",
        "onestopWorkflowTitle": "Temel özellik",
        "onestopWorkflowDescription": "WeryAI üzerinde Higgsfield AI ile yüksek kaliteli AI içeriği oluşturun.",
        "howToUseTitle": "Nasıl Kullanılır",
        "howToUseSubtitle": "WeryAI üzerinde Higgsfield AI ile yüksek kaliteli AI içeriği oluşturun.",
        "step1Title": "Model seçin",
        "step1Description": "Higgsfield'i seçin",
        "step2Title": "Açıklama girin",
        "step2Description": "Sahneyi açıklayın",
        "step3Title": "Oluştur",
        "step3Description": "Oluştur'a tıklayın",
        "youtubeTitle": "YouTube",
        "youtubeVideosTitle": "Temel özellik",
        "youtubeVideoTitle": "Temel özellik",
        "xPostsTitle": "X Gönderileri",
        "exploreModelsTitle": "Diğer modelleri keşfedin",
        "sora2Title": "Sora-2",
        "hailuoTitle": "Hailuo",
        "klingTitle": "Kling",
        "faqTitle": "SSS",
        "ctaTitle": "Hazır mısınız?",
        "ctaSubtitle": "WeryAI üzerinde Higgsfield AI ile yüksek kaliteli AI içeriği oluşturun.",
        "ctaDescription": "Şimdi başlayın",
        "ctaButton": "Deneyin",
        "ctaNote": "WeryAI üzerinde Higgsfield AI ile yüksek kaliteli AI içeriği oluşturun.",
        "ctaDisclaimer": "Kart yok",
        "videoNotSupported": "Desteklenmiyor",
        "videoUnsupported": "WeryAI üzerinde Higgsfield AI ile yüksek kaliteli AI içeriği oluşturun.",
        "videoLoadingError": "WeryAI üzerinde Higgsfield AI ile yüksek kaliteli AI içeriği oluşturun.",
        "videoLoadError": "Yükleme hatası",
        "videoReload": "Yeniden yükle"
    }
}
